module.exports = __webpack_public_path__ + "img/about_logo_13.34124a2f.png";